/**
 * Capacitor Platform Detection and Utilities
 * Provides helpers to detect if app is running natively and access native features
 */

import { Capacitor } from '@capacitor/core';

/**
 * Check if app is running as native mobile app
 */
export const isNativePlatform = () => {
  return Capacitor.isNativePlatform();
};

/**
 * Check if running on iOS
 */
export const isIOS = () => {
  return Capacitor.getPlatform() === 'ios';
};

/**
 * Check if running on Android
 */
export const isAndroid = () => {
  return Capacitor.getPlatform() === 'android';
};

/**
 * Check if running in web browser
 */
export const isWeb = () => {
  return Capacitor.getPlatform() === 'web';
};

/**
 * Get current platform name
 */
export const getPlatform = () => {
  return Capacitor.getPlatform();
};

/**
 * Check if a specific plugin is available
 */
export const isPluginAvailable = (pluginName) => {
  return Capacitor.isPluginAvailable(pluginName);
};

/**
 * Convert Capacitor platform to user-friendly string
 */
export const getPlatformDisplay = () => {
  const platform = getPlatform();
  switch (platform) {
    case 'ios':
      return 'iOS';
    case 'android':
      return 'Android';
    case 'web':
      return 'Web';
    default:
      return platform;
  }
};
